// extracted by mini-css-extract-plugin
module.exports = {"coloumnBtns":"PlayerActionButtons_coloumnBtns__1C5bc","editPlayer":"PlayerActionButtons_editPlayer__1f6mi","removePlayer":"PlayerActionButtons_removePlayer__2IJF_"};